module.exports = __webpack_public_path__ + "img/Coat_of_arms_of_Bulgaria.8effa8c2.png";